import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';

import { on } from '@ember/modifier';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';

interface Signature {
  Args: {
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}
export default class MiciBaseConsultFormImmediateStool extends Component<Signature> {
  clearChangeset = () => {
    if (!this.args.form.changeset.get('immediateStool'))
      this.args.form.changeset.set('immediateStoolUrgency', undefined);
  };

  <template>
    <@form.FieldsRadioGroup
      @propertyName='immediateStool'
      @title={{t 'mici-form.immediateStool.long' htmlSafe=true}}
      as |Group|
    >
      <Group.FieldRadio @value={{true}} @label='Oui' />
      <Group.FieldRadio
        @value={{false}}
        @label='Non'
        {{on 'click' this.clearChangeset}}
      />
    </@form.FieldsRadioGroup>
  </template>
}
